import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Popup from 'reactjs-popup';
import { SketchPicker } from 'react-color';

const contentStyle = {
  border: 'none',
  borderRadius: '8px',
  boxShadow: '0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)',
  width: '201px',
  padding: '15px 15px 10px 15px'
};

const isValidHex = (value) => {
  if (!value || typeof value !== 'string') return false;
  return /^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$/.test(value.trim());
};

const ColorPicker = ({ value, onChange, presetColors = [], inputPlaceholder = '#000000', disabled = false, position = 'bottom left', className }) => {
  const pickerColor = useMemo(() => {
    return isValidHex(value) ? value : '#000000';
  }, [value]);

  return (
    <div className={className}>
      <div className="input-group">
        <div className="input-group-prepend">
          <Popup
            arrow={false}
            offsetY={3}
            offsetX={8}
            position={position}
            className={className}
            contentStyle={contentStyle}
            trigger={(open) => (
              <span
                className="input-group-text"
                role="button"
                aria-disabled={disabled}
                style={{
                  background: '#fff',
                  cursor: disabled ? 'not-allowed' : 'pointer',
                  borderColor: '#ced4da',
                  paddingTop: 4,
                  paddingBottom: 4,
                }}
              >
                <span
                  style={{
                    display: 'inline-block',
                    width: 22,
                    height: 22,
                    borderRadius: 4,
                    border: '1px solid #ccc',
                    background: isValidHex(value) ? value : '#ffffff'
                  }}
                />
              </span>
            )}
          >
            {(close) => (
              <SketchPicker
                width={"169px"}
                color={pickerColor}
                onChange={(color) => {
                  onChange && onChange(color.hex);
                }}
                onChangeComplete={(color) => {
                  onChange && onChange(color.hex);
                }}
                presetColors={presetColors}
                disableAlpha
              />
            )}
          </Popup>
        </div>
        <input
          type="text"
          className="form-control"
          value={value || ''}
          placeholder={inputPlaceholder}
          onChange={(e) => onChange && onChange(e.target.value)}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

ColorPicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  presetColors: PropTypes.array,
  inputPlaceholder: PropTypes.string,
  disabled: PropTypes.bool,
  position: PropTypes.string,
  className: PropTypes.string
};

export default ColorPicker;


